// src/components/Footer.js

import React from "react";
import "./Footer.css"; // Optional: for styling
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaGoogle,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          © {new Date().getFullYear()} M D Tours and Travels. All rights
          reserved.
        </p>
        {/* <ul className="footer-links">
          <li>
            <a href="/about">About Us</a>
          </li>
          <li>
            <a href="/contact">Contact</a>
          </li>
          <li>
            <a href="/privacy">Privacy Policy</a>
          </li>
        </ul>{" "} */}
        <div className="footer-social">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook size={24} color="white" />
          </a>
          <a
            href="https://maps.app.goo.gl/Vbmamh2BugEwJhtw9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGoogle size={24} color="white" />
          </a>
          {/* <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter size={24} color="white" />
          </a> */}
          <a
            href="https://www.instagram.com/mdtravels_2025?igsh=MW9ydHpjNW9qNDc5aw=="
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram size={24} color="white" />
          </a>
          {/* <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={24} color="white" />
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
